import SelectOutlet from 'components/selectOutlet'
import { Field, FieldProps } from 'formik'

interface TFormikSelectProps extends React.HTMLProps<HTMLSelectElement> {
    name: string
    label: string
    Options: Array<ISelectOption>
    disabled?: boolean
    firstOption?: string
}
const FormikSelect = ({
    name,
    label,
    disabled,
    Options,
    firstOption,
    ...props
}: TFormikSelectProps) => {
    return (
        <>
            <Field as="select" name="color">
                {({ form }: FieldProps) => (
                    <>
                        <SelectOutlet
                            required={props.required}
                            label={label}
                            name={name}
                            value={form?.values[name]}
                            onBlur={() => form.setFieldTouched(name, true)}
                            errors={form?.errors[name]?.toString()}
                            touched={Boolean(form?.touched[name])}
                            options={Options}
                            disabled={disabled}
                            placeholder={props.placeholder}
                            firstOption={firstOption}
                            onChange={(
                                e: React.ChangeEvent<HTMLSelectElement>
                            ) => form?.setFieldValue(name, e.target.value)}
                        />
                    </>
                )}
            </Field>
        </>
    )
}

export default FormikSelect
